import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import NewResidenceProgramModal from "./NewResidenceProgramModal";
import { residences, residenceBeds } from "../services/soar";
import SearchBox from "../common/SearchBox";

function ResidenceProgramHomes(props) {
  const params = useParams();
  const [residenceData, setResidenceData] = useState([]);
  const [newResidence, setNewResidence] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showInactive, setShowInactive] = useState(false);
  const navigate = useNavigate();

  const applicationId =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
      : "58990f83-8566-4ba8-b4b5-584a64e4cba1";

  useEffect(() => {
    getProgramBeds();
  }, [params]);

  const getProgramBeds = async () => {
    const body = {
      command: "query",
      application: applicationId,
      keyword: "bytype",
      searchTerms: {
        type: params.program,
      },
    };
    residenceAction(body);
  };

  const residenceAction = async (body) => {
    const data = await residences(body);
    setResidenceData(data.data);
  };

  const addResidence = () => {
    setNewResidence({
      name: "",
      type: params.program,
      address: "",
      city: "",
      state: "",
      zip: "",
      unit: "",
      doorCode: "",
      leaseStatus: "",
      placementStatus: "",
      programUnit: "",
      programUnitName: "",
      externalIdentifier: "",

      company: "",
      companyName: "",
    });

    setShowModal(true);
  };

  const handleSaveNewResidence = async () => {
    const body = {
      command: "insert",
      application: applicationId,
      name: newResidence.programUnit.name,
      type: params.program,
      address: "",
      city: "",
      state: "",
      zip: "",
      unit: "",
      doorCode: "",
      externalIdentifier: "",
      placementStatus: "",
      leaseStatus: "",
      programUnit: newResidence.programUnit.id,
      programUnitName: newResidence.programUnit.name,
      company: newResidence.state.id,
      companyName: newResidence.state.name,
    };

    const response = await residences(body);
    if (response.code === "success") {
      setShowModal(false);
      for (let i = 0; i < newResidence.numberOfBeds; i++) {
        const bedBody = {
          command: "insert",
          application: applicationId,
          residence: response.id,
          name: `Bed ${i + 1}`,
          configuration: {},
        };
        const bedResponse = await residenceBeds(bedBody);
        if (bedResponse.code !== "success") {
          toast.error(`Error creating bed ${i + 1}: ${bedResponse.message}`);
        }
      }
    } else {
      toast.error(`Error saving residence: ${response.message}`);
    }

    getProgramBeds();
  };

  return (
    <div>
      <NewResidenceProgramModal
        data={newResidence}
        setData={setNewResidence}
        show={showModal}
        handleSave={handleSaveNewResidence}
        onHide={() => setShowModal(false)}
        programType={params.program}
      />
      <h1>
        {params.program
          .toLowerCase()
          .split(" ")
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(" ")}
      </h1>
      <div className="row my-4">
        <div className="col-6 mt-2">
          <SearchBox
            placeholder="Search by Address, City, or Program"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="col-4 mt-4"></div>
        <div className="col-2">
          <button
            className="btn btn-primary float-end"
            onClick={() => addResidence()}
          >
            {`Add ${params.program} Program`}
          </button>
        </div>
      </div>
      <div className="">
        {residenceData
          ?.filter((a) => showInactive || a.active)
          .filter(
            (a) =>
              a.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
              a.programUnitName
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
          )
          .sort((a, b) => {
            const nameA = (a.name || "").toLowerCase();
            const nameB = (b.name || "").toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          })
          .map((home, rindex) => (
            <div key={`residence-${rindex}`} className="mb-2">
              <div
                key={home.id}
                className={`rounded border ${
                  home.active ? "border-dark" : "border-danger border-2"
                } card-safy bg-light p-2`}
              >
                <div className="row h5 text-primary">
                  <div className="col-11">{home.name}</div>
                  <div className="col-1">
                    <i
                      className="fas fa-pen text-primary"
                      onClick={() =>
                        navigate(
                          `/residence/programs/${params.program}/${home.id}`
                        )
                      }
                    />
                  </div>
                </div>
                {home.beds.map((b) => (
                  <div key={b.id} className="row mb-1">
                    <div className="col">{`${b.name}`}</div>
                    <div className="col fw-bold">
                      {b.clientHistory?.find(
                        (h) =>
                          h.admission && (!h.discharge || h.discharge === "")
                      ) ? (
                        b.clientHistory?.find(
                          (h) =>
                            h.admission && (!h.discharge || h.discharge === "")
                        ).clientName
                      ) : (
                        <div className="rounded border border-dark bg-success text-white px-2">
                          Open
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default ResidenceProgramHomes;
